import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M12 1c5.042 0 7.606.346 8.556 2.167-.762-.294-1.593-.492-2.468-.63C16.41 2.274 14.376 2.2 12 2.2s-4.41.073-6.089.338c-.875.137-1.705.335-2.467.629C4.394 1.346 6.958 1 12 1"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C2.556 4 .226 5.188 1.207 13.5 2.188 21.813 3.537 23 12 23s9.812-1.187 10.793-9.5C23.774 5.188 21.443 4 12 4m-7 6.9V9.1h14v1.8zm7.5 3.5h-7v-1.8h7z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
CardLinesStackedFilledSize24Glyph.displayName = 'CardLinesStackedFilledSize24Glyph';
